import React from 'react'

const Bredcrumb_blog = () => {
  return (
    <div>
      <div className="bred_crumb blog_page">
  {/* animated dots */}
  <div className="dotes_anim_bloack">
    <div className="dots dotes_1" />
    <div className="dots dotes_2" />
    <div className="dots dotes_3" />
    <div className="dots dotes_4" />
    <div className="dots dotes_5" />
    <div className="dots dotes_6" />
    <div className="dots dotes_7" />
    <div className="dots dotes_8" />
    <div className="dots dotes_9" />
    <div className="dots dotes_10" />
  </div>
  <div className="container">
    <div className="bred_text blog"></div>
  </div>
</div>

    </div>
  )
}

export default Bredcrumb_blog
